// Seat allocations — how many seats (agent extensions + seatless browser
// softphones) an organisation has purchased, and which extension numbers.
//
// Granting/changing/disabling is Green Giraffe only (2026-10-14): master or
// platform admins, or an admin of the platform root organisation. The server
// enforces it; a provider gets 403 "Seat allocations are managed by Green
// Giraffe only".
import api from '../axios.config';

export interface SeatAllocation {
  id?: number;
  organizationId: string;
  grantedByOrgId?: string | null;
  rangeStart: number;
  rangeEnd: number;
  maxSeats: number;
  enabled: boolean;
  notes?: string | null;
}

export interface SeatOverviewRow {
  organizationId: string;
  organizationName: string;
  organizationType: string | null;
  parentOrganizationId: string | null;
  platformRoot: boolean;
  allocation: SeatAllocation | null;
  usedSeats: number;
}

export interface GrantRequest {
  organizationId: string;
  /** Omit both for a system-chosen range (1000 upward, covering existing seats). */
  rangeStart?: number;
  rangeEnd?: number;
  maxSeats: number;
  enabled: boolean;
  notes?: string;
  grantedByOrgId?: string;
}

const BASE = '/v1/telephony/extension-allocations';

/** ApiResponse is { success, data }; tolerate a bare body as well. */
const unwrap = <T,>(res: any): T => (res?.data?.data ?? res?.data) as T;

/** The server's own message, so its validations reach the operator verbatim. */
export const errorMessage = (e: any): string =>
  e?.response?.data?.message || e?.response?.data?.error || e?.message || 'Request failed';

export const seatAllocationsService = {
  async overview(): Promise<SeatOverviewRow[]> {
    const rows = unwrap<SeatOverviewRow[]>(await api.get(BASE));
    return Array.isArray(rows) ? rows : [];
  },
  async grant(req: GrantRequest): Promise<SeatAllocation> {
    return unwrap<SeatAllocation>(await api.post(BASE, req));
  },
};
